// extracted by mini-css-extract-plugin
export default {"headerContainer":"styles_headerContainer__2t0o6","header":"styles_header__enZuK","subHeader":"styles_subHeader__oXLm+","link":"styles_link__dY4k0"};